import React, { useState } from 'react';
import { useLocation } from 'react-router-dom';
import './Container.css';
import ReportGrid from './ReportGrid';
import ReportSideMenu from './ReportSideMenu';

function Container() {
	const [mode, setMode] = useState('calendar');
	const location = useLocation();
	const reportPageOid = location?.state?.reportPageOid ?? null;

	const baseModeButtonClass =
		'inline-flex h-9 w-9 items-center justify-center rounded-lg border transition focus:outline-none focus:ring-2 focus:ring-slate-300';

	return (
		<div className="modern-panel m-0 flex h-full min-h-full w-full flex-col bg-white p-0 pt-[25px] text-slate-900">
			<header className="mb-2 flex items-center justify-between border-b border-slate-200 px-3 pb-2">
				<h1 className="text-2xl font-bold tracking-tight text-slate-900">Reports</h1>
				<div className="flex items-center gap-2">
					<button
						type="button"
						aria-label="Calendar view"
						aria-pressed={mode === 'calendar'}
						onClick={() => setMode('calendar')}
						className={`${baseModeButtonClass} ${
							mode === 'calendar'
								? 'border-slate-900 bg-slate-900 text-white'
								: 'border-slate-300 bg-white text-slate-700 hover:bg-slate-100'
						}`}
						title="Calendar mode"
					>
						<svg viewBox="0 0 24 24" fill="none" aria-hidden="true" className="h-4 w-4">
							<rect x="3.5" y="4.5" width="17" height="16" rx="2" stroke="currentColor" strokeWidth="1.8" />
							<path d="M3.5 9.5H20.5" stroke="currentColor" strokeWidth="1.8" />
							<path d="M8 3.5V6.5" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
							<path d="M16 3.5V6.5" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
						</svg>
					</button>
					<button
						type="button"
						aria-label="Edit mode"
						aria-pressed={mode === 'edit'}
						onClick={() => setMode('edit')}
						className={`${baseModeButtonClass} ${
							mode === 'edit'
								? 'border-slate-900 bg-slate-900 text-white'
								: 'border-slate-300 bg-white text-slate-700 hover:bg-slate-100'
						}`}
						title="Edit mode"
					>
						<svg viewBox="0 0 24 24" fill="none" aria-hidden="true" className="h-4 w-4">
							<path d="M4 20H8L18.2 9.8C18.6 9.4 18.6 8.7 18.2 8.3L15.7 5.8C15.3 5.4 14.6 5.4 14.2 5.8L4 16V20Z" stroke="currentColor" strokeWidth="1.8" strokeLinejoin="round" />
							<path d="M13.5 6.5L17.5 10.5" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
						</svg>
					</button>
				</div>
			</header>

			<section className="flex h-full min-h-0 w-full flex-1 flex-col gap-0 md:flex-row">
				{/* <ReportSideMenu /> */}
				<ReportGrid isEditMode={mode === 'edit'} reportPageOid={reportPageOid} />
			</section>
		</div>
	);
}

export default Container;
